var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upload-image-wrapper" }, [
    _c("div", { staticClass: "upload-preview" }, [
      _vm.defaultImage
        ? _c("img", {
            staticClass: "preview-image",
            attrs: { src: _vm.getImage },
          })
        : !_vm.source
        ? _c("div", { staticClass: "upload-placeholder" }, [
            _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.trans("general.no_image_uploaded"))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.source
        ? _c("img", {
            staticClass: "preview-image",
            attrs: { src: _vm.source },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "upload-actions" }, [
      _vm.defaultImage
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "confirm",
                  rawName: "v-confirm",
                  value: { ok: _vm.confirmRemove(_vm.imageSource) },
                  expression: "{ok: confirmRemove(imageSource)}",
                },
              ],
              staticClass: "modern-btn modern-btn-danger",
              attrs: { type: "button" },
            },
            [_vm._v(_vm._s(_vm.trans("general.remove")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.source,
              expression: "!source",
            },
          ],
          attrs: { id: "fileselector" },
        },
        [
          _c(
            "label",
            { staticClass: "modern-btn modern-btn-primary upload-label" },
            [
              _c("input", {
                staticClass: "upload-button",
                attrs: { type: "file", id: _vm.id },
                on: { change: _vm.previewImage },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "fas fa-upload" }),
              _vm._v(" " + _vm._s(_vm.buttonText) + "\n            "),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.source
      ? _c("div", { staticClass: "upload-actions" }, [
          _c(
            "button",
            {
              staticClass: "modern-btn modern-btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.uploadImage },
            },
            [_vm._v(_vm._s(_vm.trans("general.upload")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "modern-btn modern-btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.cancelUploadImage },
            },
            [_vm._v(_vm._s(_vm.trans("general.cancel_upload")))]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }